import _get from 'lodash/get'
import { outstandingPayment } from '@/services/Payments/HomeOwner/OutstandingPayment/store'
import { ownerPaymentMethod } from '@/services/OwnerPaymentMethods/store'
import { getOwner } from '@/services/Roster/Owner/getOwner'
import { notifyError, notifyMessage } from '@/services/notify'
import { ownerAdditionalScheduledPaymentsStore } from '@/services/OwnerAdditionalScheduledPayments/store'
import { chargeTypeStore } from '@/services/ChargeType/store'
import { arSettingStore } from '@/services/ARSettings/store'

export const methods = {
  async loadPaymentMethods() {
    const selectedOwnerUser = this.authUser.ownerUsers.filter(
      f => f.ownerID === this.currentOwnerId
    )

    console.debug('selectedOwnerUser[===' + JSON.stringify(selectedOwnerUser))

    const params = {
      ownerUserID:
        selectedOwnerUser[0] !== undefined && selectedOwnerUser[0]
          ? selectedOwnerUser[0].ownerUserID
          : _get(this, 'authUser.ownerUserID', null)
    }

    await outstandingPayment
      .dispatch('getPaymentMethodList', {
        params: params
      })
      .then(({ list }) => {
        if (list) {
          this.paymentMethods = list
        }
      })
  },

  //async onInput(event) {
  //  event.target = event.target._vCleave.getRawValue().replace('$', '') //getFormattedValue()
  //},

  async loadOwnerAdditionalScheduledPayments() {
    console.debug('in loadOwnerAdditionalScheduledPayments()...')

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    await ownerAdditionalScheduledPaymentsStore
      .dispatch('getOwnerAdditionalScheduledPaymentsList', {
        ownerID: this.currentOwnerId,
        isEligible: false
      })
      .then(({ list }) => {
        this.ownerAdditionalScheduledPayments = list
      })

    loadingComponent.close()
  },

  async loadSchedulePaymentEligibleChargeTypes() {
    console.debug('in loadSchedulePaymentEligibleChargeTypes()...')

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    await chargeTypeStore
      .dispatch('getChargeTypeScheduleEligibleList', {
        hoaID: this.currentHoaId,
        isEligible: true
      })
      .then(({ list }) => {
        this.chargeTypeList = list

        console.debug('chargeTypeList=' + JSON.stringify(this.chargeTypeList))

        let counter = 0
        Array.from(this.chargeTypeList).forEach(element => {
          if (element && element != undefined) {
            if (element && element != undefined && element.chargeTypeId) {
              var filteredOwnerAdditionalPaymentAmount = this.ownerAdditionalScheduledPayments.filter(
                f => f.chargeTypeID === element.chargeTypeId
              )

              console.debug(
                'filteredOwnerAdditionalPaymentAmount[0]=' +
                  JSON.stringify(filteredOwnerAdditionalPaymentAmount[0])
              )

              if (
                filteredOwnerAdditionalPaymentAmount[0] != undefined &&
                filteredOwnerAdditionalPaymentAmount[0]
              ) {
                element.additionalScheduledAmount = this.formatter.format(
                  filteredOwnerAdditionalPaymentAmount[0].amount || 0
                )
                this.form.amount[counter] = this.formatter.format(
                  filteredOwnerAdditionalPaymentAmount[0].amount || 0
                )
              } else {
                element.additionalScheduledAmount = 0
                this.form.amount[counter] = 0
              }

              this.form.amountId[counter] = element.chargeTypeId

              counter += 1
            }
          }
        })
      })

    loadingComponent.close()
  },

  async getPaymentsEnabled() {
    const params = {
      hoaID: this.currentHoaId
    }

    await arSettingStore.dispatch('getPaymentsEnabledByHoaId', params).then(({ result }) => {
      if (result != undefined) {
        this.paymentsEnabled = result
      }

      console.debug('paymentsEnabled=' + this.paymentsEnabled)
    })
  },

  async getOwner() {
    const { owner, exception } = await getOwner({
      ownerID: this.currentOwnerId
    })

    if (exception) {
      console.debug(exception)
      return
    }

    this.scheduledOwnerPaymentMethodID = _get(owner, ['scheduledOwnerPaymentMethodID'], null)
    this.ownerPaymentMethodID = _get(owner, ['scheduledOwnerPaymentMethodID'], null)
  },

  async updateSchedulePayment() {
    console.debug('in updateSchedulePayment...')
  },

  async confirmRemoveScheduledPayment() {
    this.$buefy.dialog.confirm({
      title: 'Removing Scheduled Payment',
      message: `Are you sure you want to <b>remove</b> this scheduled payment?`,
      confirmText: 'Remove Scheduled Payment',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => await this.schedulePayment(true)
    })
  },

  async schedulePayment(remove) {
    console.debug('in schedulePayment...')
    if (!this.ownerPaymentMethodID && remove && remove === false) {
      notifyError('Please select a payment method')
      return
    }

    if (!this.ownerPaymentMethodID) {
      notifyError('Please select a payment method')
      return
    }

    if (!this.currentOwnerId) {
      notifyError('There was a problem retrieving your owner information.')
      return
    }

    this.loading = true
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    try {
      await this.onFormSubmit()

      console.debug('After form submit=' + JSON.stringify(this.ownerAdditionalScheduledPayments))

      await ownerPaymentMethod.dispatch('submitScheduledPayment', {
        ownerID: this.currentOwnerId,
        ownerPaymentMethodID: remove && remove === true ? null : this.ownerPaymentMethodID,
        scheduledDayPerMonth: null,
        payAmounts: this.chargeTypeList,
        done: ({ details }) => {
          if (details) {
            if (remove && remove === false) {
              notifyMessage(`Successfully scheduled a payment.`)
            } else if (remove && remove === true) {
              notifyMessage(`Successfully removed your scheduled payment.`)
            }
            this.reload()

            this.loading = false
          }
        }
      })
    } catch (e) {
      notifyError('There was a problem scheduling your payment.')
      loadingComponent.close()
    }

    this.loading = false
    loadingComponent.close()
  },

  async onFormSubmit() {
    console.log(
      'formData=' +
        JSON.stringify(this.formData) +
        ', form.amount=' +
        JSON.stringify(this.form.amount) +
        ', form.amountId=' +
        JSON.stringify(this.form.amountId)
    )

    let formCounter = 0

    this.form.amount.forEach(element => {
      if (element && element != undefined) {
        const tempAmount = parseFloat(
          this.form.amount[formCounter].replace('$', '').replace(',', '')
        )
        console.debug('tempAmount=' + tempAmount)
        const payAmount = tempAmount > 0 ? tempAmount : 0

        console.debug('each form amount=' + payAmount + ', ' + this.form.amountId[formCounter])

        var filteredChargeType = this.chargeTypeList.filter(
          f => f.chargeTypeId === this.form.amountId[formCounter]
        )

        if (filteredChargeType[0] != null && filteredChargeType[0]) {
          filteredChargeType[0].additionalScheduledAmount = payAmount

          console.debug('filteredChargeType[0]=' + JSON.stringify(filteredChargeType[0]))
        }

        formCounter += 1
      }
    })
  },

  async reload() {
    this.loading = true

    await this.getOwner()
    await this.loadPaymentMethods()
    await this.loadOwnerAdditionalScheduledPayments()
    await this.loadSchedulePaymentEligibleChargeTypes()
    await this.getPaymentsEnabled()

    this.loading = false
  }
}
